var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon33(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000049928663183045154400000009308068019459385502_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.4 24.7",
    style: {
      enableBackground: "new 0 0 24.4 24.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,11c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h11.4c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8H8.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,15H8.7c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h11.4c0.5,0,0.8-0.4,0.8-0.8 C20.9,15.4,20.5,15,20.1,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,19.1H8.7c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h3.6c0.5,0,0.8-0.4,0.8-0.8S12.7,19.1,12.3,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,7.4h-0.5V5.5c0-1-0.8-1.8-1.8-1.8H8.9L6.8,1C6.4,0.6,5.9,0.3,5.4,0.3H2c-1,0-1.8,0.8-1.8,1.8V21 c0,1.7,1.3,3.1,2.9,3.3l0,0h17.8c1.8,0,3.3-1.5,3.3-3.3V9.2C24.2,8.2,23.4,7.4,22.4,7.4z M19.8,7.4H6.5c-1,0-1.8,0.8-1.8,1.8V21 c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2V2.4h3l2.1,2.7c0.3,0.4,0.9,0.7,1.4,0.7h11.1v1.6H19.8z M6.5,22.3 c0.2-0.4,0.2-0.8,0.2-1.2V9.5H22v11.6c0,0.7-0.6,1.2-1.2,1.2C20.8,22.3,6.5,22.3,6.5,22.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon33);
export default __webpack_public_path__ + "static/media/icon33.dd6251f85f25bc7d59d24abed3d6584b.svg";
export { ForwardRef as ReactComponent };